import { memo } from "react";
import styled from "styled-components";
const Tracks = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Tracks",
  componentId: "sc-1nvzoip-0"
})(["position:absolute;top:6px;left:0;bottom:0;width:100%;display:flex;flex-direction:column;"]));
export default Tracks;
//# sourceMappingURL=Tracks.js.map